module.exports = __webpack_public_path__ + "img/037.bcc13e21.png";